import { forwardRef } from "react";
import { useId } from "react";
function SvgRawUndoIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M14 25h9a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3H10"
      />
      <path
        fill="#1D1D1D"
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6.045v9.91L5.629 11 12 6.045Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawUndoIcon);
export default ForwardRef;
